// extracted by mini-css-extract-plugin
module.exports = {"targetSection":"NewOwnerPicker_targetSection__2BV2w","targetHelper":"NewOwnerPicker_targetHelper__5ammV","selectedTarget":"NewOwnerPicker_selectedTarget__Z_t4M"};